import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import "firebase/performance";

// Replace this with your own config details
var config = {
    apiKey: "AIzaSyDxGNImJfUJzU8tYRc15km4WGGN6t_pWNQ",
    authDomain: "vedicplatform.firebaseapp.com",
    databaseURL: "https://vedicplatform.firebaseio.com",
    projectId: "vedicplatform",
    storageBucket: "",
    messagingSenderId: "701892223800",
    appId: "1:701892223800:web:25ac64234f2dc328"
};
firebase.initializeApp(config);
firebase.performance();

export default firebase 